// AddressModal.js
import {React, useEffect, useState} from 'react';
import { Modal, Button } from 'react-bootstrap';
import axios from 'axios';

export default function AddressModal({ show, handleClose, handleAddAddress, onSelectAddress }) {

  const [addresses, setAddresses] = useState();

  useEffect( () => {
    const token = localStorage.getItem("access_token")
    
      axios.get("https://monkeprogrammer01.pythonanywhere.com/user/get-addresses/", {
        headers: {
          Authorization: `Bearer ${token}`
        },
      }).then((response) => setAddresses(response.data))
      .catch( (error) => {console.log(error)} )

  } )

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Your Addresses</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul>
          {addresses  ? (
            addresses.map((address, index) => (
                <div key={index} className="d-flex justify-content-between align-items-center mb-2">
                <span>Город: {address.city}, Дом: {address.home}, Квартира: {address.apartment}</span>
                <Button variant="outline-primary" onClick={() => onSelectAddress(address.id)}>
                  Выбрать
                </Button>
              </div>            ))
          ) : (
            <li>No addresses found.</li>
          )}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleAddAddress}>
          Add New Address
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
